import React from 'react';
import { Factory, Globe2, Package } from 'lucide-react';

const Panel = ({ icon: Icon, eyebrow, title, children, tone }) => (
  <div className={`relative overflow-hidden rounded-xl p-4 text-white min-h-[150px] flex flex-col ${tone}`}>
    <Icon aria-hidden="true" className="absolute -right-4 -bottom-4 w-28 h-28 text-white/10" />
    <p className="text-[10px] font-extrabold uppercase tracking-widest text-teal-200">{eyebrow}</p>
    <p className="mt-1 text-sm font-extrabold">{title}</p>
    <div className="relative mt-2 text-xs text-white/85 leading-relaxed">{children}</div>
  </div>
);

// operations: utils/issueSubscription.js buildIssuerProfile().operations
export const IssueOperations = ({ operations }) => {
  const { facilities = [], products = [], presence = null } = operations || {};
  const hasContent = facilities.length || products.length || presence;

  return (
    <section aria-labelledby="operations-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
      <h2 id="operations-heading" className="flex items-center gap-2 text-sm sm:text-base font-extrabold text-slate-900">
        <Factory className="w-4 h-4 text-[#008080]" aria-hidden="true" />
        Manufacturing Infrastructure &amp; Operational Scale
      </h2>

      {hasContent ? (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
          <Panel icon={Factory} eyebrow="Facilities" title="Manufacturing & Operations" tone="bg-gradient-to-br from-slate-900 to-[#05302f]">
            {facilities.length ? facilities.join(' · ') : 'Facility locations aren’t listed in the extracted offer document.'}
            {presence && (
              <span className="mt-2 flex items-start gap-1.5">
                <Globe2 className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-teal-200" aria-hidden="true" />
                {presence}
              </span>
            )}
          </Panel>
          <Panel icon={Package} eyebrow="Portfolio" title="Products & Segments" tone="bg-gradient-to-br from-[#006666] to-[#0f766e]">
            {products.length ? (
              <ul className="flex flex-wrap gap-1.5">
                {products.map((product) => (
                  <li key={product} className="px-2 py-0.5 rounded-md bg-white/15 ring-1 ring-white/20 capitalize">
                    {product}
                  </li>
                ))}
              </ul>
            ) : (
              'Product segments aren’t listed in the extracted offer document.'
            )}
          </Panel>
        </div>
      ) : (
        <p className="mt-4 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-3 py-6 text-center text-xs text-slate-500">
          Facility and product details for this issuer haven’t been extracted from its offer document yet.
        </p>
      )}
    </section>
  );
};

export default IssueOperations;
